Vue.component('slidetoast', {
    data () {
        return {
            text: false,
            defaultTime: 2.5
        }
    },
    mounted () {
        let $this = this;
        bus.$on('toast', function(obj) {
            if (obj.text) {
                $this.text = obj.text
                document.getElementById("slidetoast").classList.add('active');
                
                setTimeout(function () {
                    document.getElementById("slidetoastinner").classList.add('active');
                }, 100)
                let t = $this.defaultTime*1000 
                if (obj.time) {
                    t = obj.time * 1000
                }

                setTimeout(function() {
                    document.getElementById("slidetoastinner").classList.remove('active');
                }, t)
                
                setTimeout(function() {
                    document.getElementById("slidetoast").classList.remove('active');
                }, t + 600)
                
            }
        })
    },
    
})